import classnames from 'classnames'
import Tracker from 'common/services/Tracker'
import { css } from 'emotion'
import * as React from 'react'
import { connect } from 'react-redux'

import { stepSelected } from 'common/actions'

import ThemeConsumer from 'embed/components/ThemeConsumer'
import { CreditCardStep, LoanStep, Product, ProductStep, TrackingKey } from 'even-ts-static'

const commonStyles = require('embed/styles/results')
const styles = require('./styles.scss')

export interface GenericCtaProps {
  buttonText: string
  contentText: string
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  image: any
  selectedStepOnClick: CreditCardStep | LoanStep
  titleText: string
  trackingEvent: TrackingKey
  isHybridStep?: boolean
}

interface StoreProps {
  selectedProduct: Product
}
interface DispatchProps {
  dispatchStepSelected: (product: Product, step: ProductStep) => void
  dispatchTrackingEvent: (action: TrackingKey) => void
}

export type Props = GenericCtaProps & StoreProps & DispatchProps

const GenericCtaView = (props: Props) => {
  const onGetStartedClick = () => {
    const { dispatchStepSelected, dispatchTrackingEvent, selectedProduct, selectedStepOnClick, trackingEvent } = props
    dispatchStepSelected(selectedProduct, selectedStepOnClick)
    dispatchTrackingEvent(trackingEvent)
  }

  const { buttonText, contentText, titleText, isHybridStep, image: CtaImage } = props

  return (
    <ThemeConsumer>
      {({
        borderRadiusLarge,
        borderRadiusSmall,
        backdropStyles,
        boxStyles,
        colorBorder,
        ctaStyles,
        colorPrimary,
        fontFamilyPrimary,
      }) => (
        <div
          className={classnames(
            commonStyles.offer,
            styles.genericCta,
            css`
              border-color: ${colorBorder};
              border-radius: ${borderRadiusLarge};
              background: ${isHybridStep ? backdropStyles.backgroundColor : '#fff'};
            `,
          )}
          style={boxStyles}
        >
          <div className={styles.content}>
            <div className={classnames(styles.imageContainer)}>
              <div
                className={classnames(
                  styles.imageContainerBackground,
                  css`
                    background: ${isHybridStep ? '#fff' : colorPrimary};
                    opacity: 0.1;
                  `,
                )}
              />
              {CtaImage && (
                <CtaImage
                  className={classnames(
                    styles.image,
                    css`
                      path {
                        fill: ${colorPrimary};
                      }
                    `,
                  )}
                />
              )}
            </div>
            <div className={styles.text}>
              <div id="generic-cta-title" className={styles.title}>
                {titleText}
              </div>
              <div id="generic-cta-content">{contentText}</div>
            </div>
          </div>
          <div className={classnames(commonStyles.cta, styles.cta)}>
            <button
              className={classnames(
                commonStyles.button,
                styles.button,
                css(`
                  background-color: ${isHybridStep ? ctaStyles?.backgroundColor : colorPrimary};
                  border-radius: ${borderRadiusSmall};
                  font-family: ${fontFamilyPrimary};
                  &:hover {opacity: 0.84;}
                `),
              )}
              onClick={onGetStartedClick}
            >
              {buttonText}
            </button>
          </div>
        </div>
      )}
    </ThemeConsumer>
  )
}

const mapStateToProps = (state): StoreProps => ({
  selectedProduct: state.ui.selectedProduct,
})

const mapDispatchToProps = (dispatch): DispatchProps => ({
  dispatchStepSelected: (product: Product, step: ProductStep) => dispatch(stepSelected(product, step)),
  dispatchTrackingEvent: (actionType: TrackingKey) => {
    Tracker.trackEvent({
      action: actionType,
      data: {},
      timestamp: new Date(),
    })
  },
})

export const GenericCta = connect<StoreProps, DispatchProps, GenericCtaProps>(
  mapStateToProps,
  mapDispatchToProps,
)(GenericCtaView)
